<template>
  <div class="row px-gap mb-2 mb-4">
    <div class="col-md-6">
      <div class="row bg-white rounded shade mr-2">
        <div class="col-md-4" data-v-step="1">
          <loader-component v-if="isLoading" />
          <card-dynamic-component
            v-else
            card_title="Mention"
            :card_content="stats != null ? stats.mention.toString() : '0'"
            number_color="purple"
            card_icon="bi bi-chat-dots-fill"
          />
        </div>
        <div class="col-md-4" data-v-step="2">
          <loader-component v-if="isLoading" />
          <card-dynamic-component
            v-else
            card_title="Reach"
            :card_content="stats != null ? stats.reach.toString() : '0'"
            number_color="orange"
            card_icon="bi bi-megaphone"
          />
        </div>
        <div class="col-md-4" data-v-step="3">
          <loader-component v-if="isLoading" />
          <card-dynamic-component
            v-else
            card_title="Engagement"
            :card_content="stats != null ? stats.engagement.toString() : '0'"
            number_color="cyan"
            card_icon="bi bi-share-fill"
          />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row bg-white rounded shade ml-2">
        <div class="col-md-4" data-v-step="4">
          <loader-component v-if="isLoading" />
          <card-dynamic-component
            v-else
            card_title="Sentimen Positif"
            :card_content="stats != null ? stats.positif.toString() : '0'"
            :dalam_kurung="
              stats != null ? stats.persentase.positif.toString() + '%' : '0%'
            "
            number_color="success"
            card_icon="bi bi-emoji-smile"
          />
        </div>
        <div class="col-md-4" data-v-step="5">
          <loader-component v-if="isLoading" />
          <card-dynamic-component
            v-else
            card_title="Sentimen Netral"
            :card_content="stats != null ? stats.netral.toString() : '0'"
            :dalam_kurung="
              stats != null ? stats.persentase.netral.toString() + '%' : '0%'
            "
            number_color="complete"
            card_icon="bi bi-emoji-neutral"
          />
        </div>
        <div class="col-md-4" data-v-step="6">
          <loader-component v-if="isLoading" />
          <card-dynamic-component
            v-else
            card_title="Sentimen Negatif"
            :card_content="stats != null ? stats.negatif.toString() : '0'"
            :dalam_kurung="
              stats != null ? stats.persentase.negatif.toString() + '%' : '0'
            "
            number_color="danger"
            card_icon="bi bi-emoji-frown"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import card_dynamic from "@/views/components/dashboard/card_dynamic.vue";
import loader_component from "@/views/components/loader.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "medsos_score_card",
  components: {
    "card-dynamic-component": card_dynamic,
    "loader-component": loader_component,
  },
  props: {
    stats: Object,
    isLoading: Boolean,
  },
  filters: {
    number_format: function (number) {
      return gp.kmbFormatter(number);
    },
  },
};
</script>